import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { connect } from "react-redux";
import { incrementCounter, decrementCounter } from "../actions";
import { _t } from "../util/Translator";

class Header extends Component {
  state = {
    classMenu: "collapse navbar-collapse zero-sidebar-menu py-3 px-3"
  };

  classShowMenu = 'collapse navbar-collapse zero-sidebar-menu py-3 px-3 show';
  classHideMenu = 'collapse navbar-collapse zero-sidebar-menu py-3 px-3';

  toggleMenuClick = () => {
    if (this.state.classMenu ===  this.classHideMenu) {
      this.setState({ classMenu: this.classShowMenu})
    }else{
      this.setState({ classMenu: this.classHideMenu})
    }
  }
  componentDidMount() {
  }

  onUpdateText = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  render() {
    const { selectedLanguage, onChangeLanguage } = this.props;

    return (
      <Fragment>
        <header className="sticky-top py-3 bg-light border-bottom-0 zero-text-hanken zero-text-regular px-3 px-lg-0">
          <nav className="navbar navbar-expand-lg navbar-light zero-container">
            <a href="http://hubtalent.es" className="nav-link zero-text-regular px-lg-3 py-3 py-lg-0">  
              <img className="site-logo img-fluid" alt="" src={process.env.PUBLIC_URL + "/hubtalent-logo.svg"} />
            </a>
            <button
              onClick={() => this.toggleMenuClick()}
              className="navbar-toggler"
              type="button"
            >
              <span className={ this.state.classMenu ===  this.classHideMenu ? 'navbar-toggler-icon' : 'navbar-toggler-icon close'}></span>
            </button>

            <div className={this.state.classMenu} id="navbarColor02">
              <ul className="navbar-nav ml-lg-5 mr-auto align-items-lg-center">
                <li className="nav-item py-lg-1 d-lg-none" onClick={ this.toggleMenu }>
                  <a href="http://hubtalent.es" className="nav-link zero-text-regular px-lg-3 py-3 py-lg-0">  
                    <img className="site-logo" alt="" src={process.env.PUBLIC_URL + "/hubtalent-logo.svg"} />
                  </a>
                </li>
                <li className="nav-item pt-5 py-lg-1 zero-border-b-1">
                  <a href="http://hubtalent.es/sobre-nosotros/" className="nav-link zero-text-regular px-lg-3 py-3 py-lg-0">
                    {_t("header.empresa")}
                  </a>
                </li>
                <li className="nav-item py-1 zero-border-b-1">
                  <a href="http://hubtalent.es/servicios/" className="nav-link zero-text-regular px-lg-3 py-3 py-lg-0">
                    {_t("header.servicios")}
                  </a>
                </li>
                <li className="nav-item dropdown py-1 zero-border-b-1">
                  <a className="nav-link zero-text-regular dropdown-toggle px-lg-3"
                    href="#"
                    id="navbarDropdownMenuLink"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {_t("header.sectores")}
                  </a>
                  <div
                    className="dropdown-menu border-0 zero-shadow-dropdown"
                    aria-labelledby="navbarDropdownMenuLink"
                  >
                    <a
                      className="dropdown-item zero-text-18 py-2"
                      href="https://hubtalent.es/accounting-finance/"
                    >
                      {_t("header.accountingFinance")}
                    </a>
                    <a
                      className="dropdown-item zero-text-18 py-2"
                      href="https://hubtalent.es/digital-product-ecommerce/"
                    >
                      {_t("header.digitalProductEcommerce")}
                    </a>
                    <a
                      className="dropdown-item zero-text-18 py-2"
                      href="https://hubtalent.es/energia-ingenieria-e-infraestructura/"
                    >
                      {_t("header.energíaIngenieríaInfraestructura")}
                    </a>
                    <a
                      className="dropdown-item zero-text-18 py-2"
                      href="https://hubtalent.es/fiscal-legal/"
                    >
                      {_t("header.fiscalLegal")}
                    </a>
                    <a
                      className="dropdown-item zero-text-18 py-2"
                      href="https://hubtalent.es/industry-supply-chain/"
                    >
                      {_t("header.industrySupplyChain")}
                    </a>
                    <a
                      className="dropdown-item zero-text-18 py-2"
                      href="https://hubtalent.es/it/"
                    >
                      {_t("header.it")}
                    </a>
                    <a
                      className="dropdown-item zero-text-18 py-2"
                      href="https://hubtalent.es/recursos-humanos/"
                    >
                      {_t("header.recursosHumanos")}
                    </a>
                    <a
                      className="dropdown-item zero-text-18 py-2"
                      href="https://hubtalent.es/sales-marketing/"
                    >
                      {_t("header.salesMarketing")}
                    </a>
                  </div>
                </li>


                <li className="nav-item py-1 zero-border-b-1">
                  <a href="https://hubtalent.es/contacto/" className="nav-link zero-text-regular px-lg-3 py-3 py-lg-0">
                    {_t("header.contacto")}
                  </a>
                </li>
              </ul>
              <ul className="navbar-nav align-items-lg-center">
                <li className="nav-item align-self-lg-center py-3 py-lg-1 px-0 px-lg-3">
                  <div className="d-flex align-items-center" onClick={() => this.toggleMenuClick()}>
                    <a
                      className="zero-text-regular zero-text-color-primary"
                      href="#"
                      onClick={e => onChangeLanguage("es")}
                    >
                      {_t("header.language-short-es")}
                    </a>
                    <span className="mx-1" style={{ "lineHeight": "0" }}>|</span>
                    <a
                      className="zero-text-regular zero-text-color-primary pr-3"
                      href="#"
                      onClick={e => onChangeLanguage("en")}
                    >
                      {_t("header.language-short-en")}
                    </a>

                  </div>
                </li>
                <li className="nav-item" onClick={ this.toggleShowMenu }>
                  <HashLink to="/jobs" className="nav-link zero-text-regular px-3 btn btn-header" onClick={() => this.toggleMenuClick()}>
                    {_t("header.ofertas")}
                  </HashLink>
                </li>
              </ul>
            </div>

          </nav>
        </header>

      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  //console.log("imagenes:", state.images);
  return { counter: state.counter, imagenes: state.images };
};

export default connect(mapStateToProps, {
  incrementCounter,
  decrementCounter
})(Header);
